import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'
import { PlusIcon } from 'lucide-react'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { CardExtendTable } from '@/components/ui/card-extend'

import { itemCategoryApi } from '@/features/inventory/api/item-category-api'
import type { ItemCategoryDto } from '@/features/inventory/dto/item-category-dto'

export const Route = createFileRoute('/_app/inventory/category/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <CategoryTable />
    </Page>
  )
}

function CategoryTable() {
  const { data, isLoading } = useQuery({ ...itemCategoryApi.list.query({}) })

  const columns = useMemo(() => getColumns(), [])
  const table = useDataTable({
    columns,
    isLoading,
    data: data?.data.categories ?? [],
  })

  return (
    <CardExtendTable
      title='Daftar Kategori Bahan Baku'
      action={
        <Button asChild>
          <Link to='/inventory/category/create'>
            <PlusIcon /> Tambah Kategori
          </Link>
        </Button>
      }
    >
      <DataTable.Root table={table}>
        <DataTable.Table />
        <DataTable.Pagination />
      </DataTable.Root>
    </CardExtendTable>
  )
}

function getColumns(): ColumnDef<ItemCategoryDto>[] {
  return [
    {
      accessorKey: 'name',
      header: 'Nama',
      minSize: 180,
      cell: ({ row }) => (
        <Cell.Link
          from={Route.fullPath}
          to='/inventory/category/update/$id'
          params={{ id: row.original.id }}
        >
          {row.original.name}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'desc',
      header: 'Deskripsi',
      cell: ({ row }) => <Cell.Text text={row.original.desc} />,
    },
    {
      accessorKey: 'isActive',
      header: 'Aktif',
      cell: ({ row }) => <Cell.Text text={row.original.isActive ? 'Ya' : 'Tidak'} />,
    },
    {
      accessorKey: 'updatedAt',
      header: () => 'Updated At',
      cell: ({ row }) => <Cell.Date date={row.original.updatedAt} />,
    },
    {
      accessorKey: 'createdAt',
      header: () => 'Created At',
      cell: ({ row }) => <Cell.Date date={row.original.createdAt} />,
    },
  ]
}
